<template>
    <div>
        <v-row>
            <v-col cols="12" md="4" class="d-flex">
                <h4 class="text--gray parametros__sistema__h4">
                    Ação Reenviar contrato via WhatsApp por Marcas
                </h4>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="10" style="display: inline-flex">
                <v-radio-group v-model="Options.ReenvioWhatsapp" row style="margin-top: 7px; margin-right: -20px; padding-top: 0">
                    <v-radio label="Desabilitar" :value="0"></v-radio>
                    <v-radio label="Habilitar" :value="1"></v-radio>
                    <v-radio label="Habilitar para:" :value="2"></v-radio>
                </v-radio-group>
                <div class="div--comboBox" :style="{ 'margin-bottom': isEnabled.ReenvioWhatsapp ? '-26px !important' : '' }">
                    <DynamicSelect placeholder="Selecione as marcas" v-model="marcasSelecionadas.ReenvioWhatsapp" endpoint="/dynamic-selects/flavors/id" :class="{ isDisabled: !isEnabled.ReenvioWhatsapp, comboBoxEnorme: true }" :disabled="!isEnabled.ReenvioWhatsapp" confirm-on-clear />
                </div>
            </v-col>
            <v-col cols="12" md="10">
                <v-switch v-model="envioAutomatico.ReenvioWhatsapp" :label="switchLabel" :disabled="Options.ReenvioWhatsapp === 0"></v-switch>
            </v-col>
            <v-col cols="12" md="10">
                <v-switch v-model="Options.ExibirConsentimentoWhatsapp" :label="`Exibir opção de consentimento para contato por mensagens/Whatsapp: ${Options.ExibirConsentimentoWhatsapp ? 'Habilitado' : 'Desabilitado'}`" />
            </v-col>
        </v-row>
    </div>
</template>

<script>
  import { notification } from '@/plugins/helpers'
  import { ValuesFunctionalities } from '@/plugins/constants'
  import { AlertTypes } from '../../../plugins/alerts_types'

  export default {
    name: 'ConfiguracoesPorMarca',
    props: {
      shouldSaveRestricoesMarcas: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      Options: {
        ReenvioWhatsapp: 0,
        HabilitarGruposPraJa: 0,
        ExibirConsentimentoWhatsapp: 0
      },
      OptionsEach: ['ReenvioWhatsapp'],
      marcasSelecionadas: {
        ReenvioWhatsapp: [],
        HabilitarGruposPraJa: []
      },
      NomeFuncionalidade: {
        ReenvioWhatsapp: 'ReenvioWhatsapp',
        HabilitarGruposPraJa: 'HabilitarGruposPraJa',
        ExibirConsentimentoWhatsapp: 'ExibirConsentimentoWhatsapp'
      },
      NomeColunas: {
        ReenvioWhatsapp: 'reenvio_whatsapp',
        HabilitarGruposPraJa: 'habilitar_grupopraja',
        ExibirConsentimentoWhatsapp: 'exibir_consentimento_whatsapp'
      },
      isEnabled: {
        ReenvioWhatsapp: false,
        HabilitarGruposPraJa: false,
        ExibirConsentimentoWhatsapp: false
      },
      envioAutomatico: {
        ReenvioWhatsapp: false,
        HabilitarGruposPraJa: false,
        ExibirConsentimentoWhatsapp: false
      },
      switch1: false
    }),
    computed: {
      switchLabel () {
        return `Envio automático de contratos via WhatsApp: ${this.envioAutomatico.ReenvioWhatsapp ? 'Habilitado' : 'Desabilitado'}`
      }
    },
    watch: {
      'Options.ReenvioWhatsapp' (newValue) {
        this.isEnabled.ReenvioWhatsapp = newValue === 2
        if (newValue === 0) {
          this.envioAutomatico.ReenvioWhatsapp = false
        }
      }
    },
    mounted () {
      this.SetarDadosFuncionalidadesMarcas([])
    },
    methods: {
      async SetarDadosFuncionalidadesMarcas () {
        try {
          await this.$http.post('/painel/configuracao/restricoes_marcas/get', { nome_colunas: this.NomeColunas }).then(response => {
            let data = response.data.restricoes
            data.forEach(dado => {
              this.Options[dado.funcionalidade] = dado.config
              this.marcasSelecionadas[dado.funcionalidade] = JSON.parse(dado.marcas)
              this.envioAutomatico[dado.funcionalidade] = dado.envio_automatico_contrato
            })
          })
        } catch (e) {
          console.error(e)
          notification('error', 'Erro ao setar as restrições por marcas no painel administrativo.')
        }
      },
      limparCampos () {
        let options = Object.keys(this.Options)
        options.forEach(option => {
          if (this.Options[option] !== ValuesFunctionalities.HABILITAR_PARA && this.marcasSelecionadas[option] && this.marcasSelecionadas[option].length > 0) {
            this.marcasSelecionadas[option] = []
          }
        })
      },
      async salvarRestricoesMarcas () {
        if (this.Options.ReenvioWhatsapp === ValuesFunctionalities.HABILITAR_PARA && this.marcasSelecionadas.ReenvioWhatsapp.length === 0) {
          notification(AlertTypes.WARN, 'Necessário informar ao menos 1 marca para acesso das funcionalidades listadas.')
          return
        }
        this.limparCampos()
        try {
          await this.$http.post('/painel/configuracao/restricoes_marcas/salvar', {
            options: this.Options,
            marcas: this.marcasSelecionadas,
            nome_funcionalidade: this.NomeFuncionalidade,
            nome_colunas: this.NomeColunas,
            envio_automatico_contrato: this.envioAutomatico
          })
        } catch (e) {
          notification(AlertTypes.ERROR, 'Erro ao atualizar as restrições por marcas')
        }
      }
    }
  }

</script>

<style scoped>
.v-card__text {
    margin-top: 8px;
}

.row {
    align-items: center;
}

.v-input__control {
    align-items: center;
    justify-items: center;
}

.v-input {
    display: flex;
    align-items: center;
}

.v-input--selection-controls {
    margin-top: 1.5rem;
}

.mt-7 {
    align-self: flex-end;
}

.inline-anti-quebra-layout {
    display: inline-flex;
}

h3 {
    margin-bottom: 20px;
}

.div--comboBox {
    width: 65%;
    overflow: auto;
    max-height: 250px;
}

.comboBoxEnorme {
    max-width: 100%;
    margin-bottom: 0px !important;
    max-height: 230px;
    margin: 16px !important;
}

.comboBox_container {
    width: 100%;
    max-height: fit-content;
}

.comboBox {
    width: 100%;
    overflow: auto;
    margin: 16px;
    margin-left: 0px !important;
    max-height: fit-content;
}

.parametros__sistema__h4 {
    margin-top: 15px;
    margin-bottom: 15px;
}

.isDisabled {
    overflow: hidden !important;
    border-radius: 10px;
    background-color: #efefef !important;
}

@media (max-width: 1360px) {
    .comboBoxEnorme {
        max-width: 40%;
        margin-top: 0px !important;
        margin: 20px !important;
    }
}

@media (max-width: 1600px) {
    .comboBoxEnorme {
        max-width: 100%;
        margin-top: 0px !important;
        padding-top: 0;
        max-height: 100%;
        margin: 16px !important;
    }

    .div--comboBox {
        max-width: 55%;
        max-height: 260px;
    }
}
</style>
